import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'Do I need technical staff to set this up?',
      answer: 'No! Setup is simple and intuitive. You upload your menu (burgers, shawarmas, drinks, etc.), set prices, and go live. If you can use Instagram, you can use EasyOrder. We also provide free setup assistance on Pro plans.'
    },
    {
      question: 'What if a customer wants to speak to a real person?',
      answer: 'They can request human service anytime, and you\'ll get instant notification to take over the chat. But honestly? 95% of customers prefer the fast AI service—they get order confirmation in under 60 seconds.'
    },
    {
      question: 'Does it work for shawarmas, burgers, pizzas, etc?',
      answer: 'Yes! It\'s specifically built for fast food delivery. The AI knows how to ask about toppings, sizes, combos, and delivery details. Works perfectly for any quick-service restaurant across Middle East and Europe.'
    },
    {
      question: 'How much money will I actually make?',
      answer: 'Average restaurants see 40-50% more orders because: 1) You catch 100% of orders (no missed calls), 2) AI upsells automatically ("Add fries for $2?"), and 3) You take orders 24/7. Most shops see ROI within the first week.'
    },
    {
      question: 'What if I already have staff taking orders?',
      answer: 'Perfect—now they can focus on cooking and quality instead of answering phones. Or, save $1,200-$2,400/month by replacing order-takers entirely. Your choice. EasyOrder optimizes your team for strategic tasks.'
    },
    {
      question: 'Is there a contract? Can I cancel?',
      answer: 'Zero contract. Cancel anytime with one click. No hidden fees, no penalties. But once you see the extra orders rolling in while you\'re cooking, you won\'t want to. 30-day free trial to prove it.'
    }
  ];

  return (
    <section className="py-20 md:py-32 px-6 md:px-12" data-testid="faq-section">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-wide uppercase text-primary bg-primary/10 px-4 py-2 rounded-full inline-block mb-4">
            Frequently Asked Questions
          </span>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Everything You Need to Know
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Answers to what every restaurant owner asks before automating
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white border border-border/50 rounded-2xl px-6 shadow-sm hover:shadow-md transition-all"
                data-testid={`faq-${index}`}
              >
                <AccordionTrigger className="text-left font-semibold text-foreground hover:text-primary py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-16 text-center bg-primary/10 p-10 rounded-3xl"
        >
          <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Still have questions? We're here to help.
          </h3>
          <p className="text-muted-foreground mb-6">
            Chat with us on WhatsApp or schedule a 15-minute demo call
          </p>
          <a
            href="https://app.easyorder.delivery/informacoes"
            data-testid="cta-contact-sales"
            className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all inline-block"
          >
            Talk to Our Team
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;